<app-header></app-header>

@if(environment.HeroConfig){
    <app-hero></app-hero>
}

@if(environment.AboutConfig){
    <app-about></app-about>
}

@if(environment.FeatureConfig){
<app-feature-cards></app-feature-cards>
}

@if(environment.ActivitiesConfig){
    <app-activities></app-activities>
}

@if(environment.GalleryConfig){
    <app-gallery></app-gallery>
}

@if(environment.ReviewConfig){
    <app-reviews></app-reviews>
}

@if(environment.ContactConfig){
    <app-contact></app-contact>
}

@if(environment.BookingConfig){
    <app-booking></app-booking>
}

@if(environment.FooterConfig){
    <app-footer></app-footer>
}
